import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { Observable, from, throwError, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { ToastController } from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseurl = environment.Baseurl;
 // private iid =  environment.institute_id;

 public user = new Subject<any>();
 public user$ = this.user.asObservable();

 public studentImage = new Subject<any>();
 public studentImage$ = this.studentImage.asObservable();

 public isLoggedIn = new Subject<any>();
 public isLoggedIn$ = this.isLoggedIn.asObservable();

 public studentName = new Subject<any>();
 public studentName$ = this.studentName.asObservable();

 public studenGender = new Subject<any>();
 public studenGender$ = this.studenGender.asObservable();

 public menuItems = new Subject<any>();
 public menuItems$ = this.menuItems.asObservable();

 public webDashboard = new Subject<any>();
 public webDashboard$ = this.webDashboard.asObservable();

 private loggedInStatus = false;

  private header = new Headers({ 'Content-Type': 'application/json', 'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/62.0.3202.94 Safari/537.36' });
  private options = new RequestOptions({ headers: this.header });
  constructor(
    private http: HttpClient,
    private toast: ToastController,
    ) {
      
     }

  errorHandler(errors: HttpErrorResponse) {
    if (errors.error instanceof ErrorEvent) {
      console.error('An error occurred:', errors.error.message);
    } else {
      console.error(
        `Backend returned code ${errors.status}, ` +
        `body was: ${errors.error}`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  }

  async showToast(displayMessage: string, position?: 'bottom' | 'top' | 'middle', duration?: number) {
    const toast = await this.toast.create({
      message: displayMessage,
      duration: duration || 3000,
      position: position || 'bottom'
    });
    toast.present();
  }
  onLogin(data) {
    const url = this.baseurl + '/StudentLogin/';
    return this.http.post(url, data)
    .pipe(map((resp: any) => {
        return resp;
    }), catchError(this.errorHandler));
  }

  onLoginFaculty(user) {
    let url = this.baseurl + '/FacultyLogin/';
    return this.http.post(url, user)
    .pipe(map((resp: any) => {
      return resp;
    }), catchError(this.errorHandler));
  }

  onLoginAdmin(data) {
    const url = this.baseurl + '/Login/';
    return this.http.post(url, data)
    .pipe(map((resp: any) => {
        return resp;
    }), catchError(this.errorHandler));
  }

  demo(){
    console.log("called");
  }

  updateUserProfile(data){
    console.log(data)
    const url = this.baseurl + '/Student/';
    return this.http.put(url, data)
    .pipe(map((resp: any) => {
        return resp;
    }), catchError(this.errorHandler));
  }

  getStudentProfile(id){
    const url = this.baseurl + '/Student/' + id;
    return this.http.get(url)
    .pipe(map((resp: any) => {
        return resp;
    }), catchError(this.errorHandler));
  }

  getStudentNotification(id): Observable<any> {
    const url = this.baseurl + '/StudentNotification?student_id=' + id;
    return this.http.get(url)
    .pipe(map((resp: any) => {
        return resp;
    }), catchError(this.errorHandler));
  }

  removeToken(token){
    const url = this.baseurl + '/AuthToken/' + token;
    return this.http.delete(url)
    .pipe(map((resp: any) => {
      return resp;
    }), catchError(this.errorHandler));
  }

  setNewUser(userInfo) {
    console.log(userInfo);
    const url = this.baseurl + '/Student';
    return this.http.post(url, userInfo)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  //https://edusome.azurewebsites.net/api/User?id=416
}
